import * as React from "react";

function IDCell(props) {
    const { hidden, ...otherProps } = props;
    return (
        <td
            {...otherProps}
            className="align-items-center"
            style={{
                touchAction: "none",
            }}
        >
            <span className={`d-flex align-items-center${hidden && " text-muted"}`}>
                <span
                    className="fas fa-grip-vertical pe-2"
                    style={{
                        cursor: hidden ? "" : "move",
                        fontSize: "14px"
                    }}
                    data-drag-handle={true}
                />
                &nbsp;
                {
                    props.dataItem['#']
                }
            </span>
        </td>
    );
};

export default IDCell;